// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__-CcW9","inputImg":"UserPhotoPost_inputImg__tvrng","preview":"UserPhotoPost_preview__BaXg2"};